<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<ng-container *ngIf="pane && (rideOpsUi.isV2Active$ | async); else v1QueueWidget">
	<div class="queue-widget-v2" *ngIf="settings$ | async as settings">
		<header class="queue-widget-v2-header">
			<h2 class="queue-widget-v2-title">{{ "WIDGET__QUEUE_TIME" | transloco }}</h2>
			<div
				class="queue-widget-v2-updated"
				[style.visibility]="(lastUpdated$ | async) ? 'visible' : 'hidden'"
			>
				<span>{{ "WIDGET__UPDATED" | transloco }}</span>
				<span>&nbsp;</span>
				<last-updated
					[lastUpdated]="lastUpdated$"
					[warningThreshold]="settings.warningThreshold"
					[icon]="null"
				></last-updated>
			</div>
		</header>

		<div class="queue-widget-v2-slider">
			<ion-range
				class="queue-widget-v2-range"
				(ionInput)="onQueueTimeInput($event)"
				[ngModel]="queueTime"
				pin="false"
				min="0"
				[max]="settings.maximum"
				snaps="false"
				ticks="false"
				[step]="settings.stepSize"
				[mode]="'ios'"
			></ion-range>
		</div>

		<div class="queue-widget-v2-action">
			<div class="queue-widget-v2-time" *ngIf="queueTimeSpan">
				<div class="queue-widget-v2-time-part">
					<div class="queue-widget-v2-time-value">{{ padQueuePart(queueTimeSpan.hours) }}</div>
					<div class="queue-widget-v2-time-label">{{ "WIDGET__HOURS" | transloco }}</div>
				</div>
				<div class="queue-widget-v2-time-separator" aria-hidden="true">
					<div class="queue-widget-v2-time-value">:</div>
					<div class="queue-widget-v2-time-label">&nbsp;</div>
				</div>
				<div class="queue-widget-v2-time-part">
					<div class="queue-widget-v2-time-value">{{ padQueuePart(queueTimeSpan.minutes) }}</div>
					<div class="queue-widget-v2-time-label">{{ "WIDGET__MINUTES_SHORT" | transloco }}</div>
				</div>
			</div>

			<button
				type="button"
				class="queue-widget-v2-submit"
				[class.queue-widget-v2-submit--disabled]="updateDisabledRemainingSeconds > 0"
				[class.queue-widget-v2-submit--warning]="(lastUpdatedIsExpired$ | async) === true"
				[class.queue-widget-v2-submit--cooldown]="updateDisabledRemainingSeconds > 0"
				[disabled]="updateDisabledRemainingSeconds > 0"
				(click)="submit()"
			>
				@if (updateDisabledRemainingSeconds > 0) {
					<span class="queue-widget-v2-submit-label">
						<span class="queue-widget-v2-submit-label-primary">
							{{ "WIDGET__DISPATCH_ON_HOLD" | transloco }}
						</span>
						<span class="queue-widget-v2-submit-label-secondary">
							{{
								"WIDGET__DISPATCH_ON_HOLD_SECONDS"
									| transloco: { seconds: updateDisabledRemainingSeconds }
							}}
						</span>
					</span>
				} @else {
					<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
						update
					</span>
					<span>{{ "WIDGET__UPDATE" | transloco }}</span>
				}
			</button>
		</div>
	</div>
</ng-container>

<ng-template #v1QueueWidget>
	<ion-card
		class="queue-widget"
		*ngIf="settings$ | async as settings"
		[ngClass]="{ warning: (lastUpdatedIsExpired$ | async) }"
	>
		<ion-card-header>
			<ion-card-title>
				<last-updated
					[lastUpdated]="lastUpdated$"
					[warningThreshold]="settings.warningThreshold"
				></last-updated>
				<div *ngIf="showSettings$ | async" class="settings-button" (click)="showSettings($event)"></div>
			</ion-card-title>
		</ion-card-header>

		<ion-card-content>
			<div class="container">
				<ion-range
					class="queue-time-picker"
					(ionInput)="queueTimeChanged()"
					[(ngModel)]="queueTime"
					color="primary"
					pin="false"
					min="0"
					[max]="settings.maximum"
					snaps="false"
					ticks="true"
					[step]="settings.stepSize"
					[mode]="'ios'"
					labelPlacement="start"
					label="0"
				></ion-range>

				<ion-button class="update-button" (click)="submit()" shape="round">
					{{ "WIDGET__SET_QUEUE_TIME" | transloco }}
				</ion-button>

				<div class="current-queue-time">
					<div class="centered-column hours" *ngIf="queueTimeSpan.hours > 0">
						<div class="number">{{ queueTimeSpan.hours }}</div>
						<div class="text">{{ "WIDGET__HOURS" | transloco }}</div>
					</div>
					<div class="centered-column">
						<div class="number">{{ queueTimeSpan.minutes }}</div>
						<div class="text">{{ "WIDGET__MINUTES" | transloco }}</div>
					</div>
				</div>
			</div>
		</ion-card-content>
	</ion-card>
</ng-template>
